import { Flavour } from 'types/Flavour'
import Icon from './Icon'

interface FlavourIconProps {
  flavour: Flavour
  bw?: boolean
}

export default function FlavourIcon ({ flavour, bw = false }: FlavourIconProps): JSX.Element {
  const iconName = flavour === 'archive' ? 'icon-archive' : `icon-bottle-${flavour}`

  return <Icon name={iconName} className={`vm w6${bw ? ' flavour-icon-bw' : ''}`} />
}
